export default {
  pageTitle: '勤務先管理',
  basicInfo: '基本情報',

  // 表单字段
  name: '勤務先名',
  postalCode: '所在地　郵便番号',
  prefecture: '都道府県',
  detailedAddress: '詳細住所',
  address: '所在地',
  nearestStation: '最寄駅',
  phone: '電話番号',
  businessHours: '営業時間',
  businessHoursDescription: '営業時間の説明',
  constitute: '勤務先の人員構成',
  images: '写真',
  lastEditTime: '最終更新日時',
  addTime: '登録日時',
  addedBy: '登録者',
  addDate: '登録日',

  // 按钮和操作
  addDepartment: '勤務先登録',
  detailTitle: '勤務先詳細',
  editTitle: '勤務先編集',

  // 占位符
  inputPlaceholder: '入力してください',
  constitutePlaceholder: '人数構成、男女比率、平均年齢、教育係の概要、などを入力してください。',
  imageHint: '対応形式：jpg / jpeg / png / webp\n1ファイル10MB未満、最大6枚までアップロードできます。\nアプリに公開する際に使用されます。',
  selectPlaceholder: '選択してください',

  // 验证信息
  validation: {
    nameRequired: '勤務先名を入力してください',
    nameDuplicate: '入力された勤務先名はすでに登録済みです',
    postalCodeRequired: '郵便番号を入力してください',
    postalCodeHalfWidth: '郵便番号は半角数字で入力してください',
    phoneRequired: '電話番号を入力してください',
    addressRequired: '住所を入力してください',
    addressPrefectureRequired: '都道府県を選択してください',
    addressCityRequired: '市区町村を選択してください',
    addressDetailRequired: '町名丁目番地号等を入力してください',
    businessHoursRequired: '営業時間を選択してください',
    imagesRequired: '少なくとも1枚の画像をアップロードしてください',
  },

  // 时间选择器
  timeRangePicker: {
    startTimePlaceholder: '開始',
    endTimePlaceholder: '終了',
    sameDay: '当日',
    nextDay: '翌日',
  },

  // 空状态
  emptyStates: {
    noData: {
      title: 'データなし',
      description: 'まだ勤務先が作成されていません'
    }
  },
  deleteDialog: {
    title: '勤務先削除',
    content: '削除すると元に戻せません。勤務先「 {name}」を削除してよろしいですか？',
    warningContent: '勤務先「 {name}」で求人が公開された記録があるため、現在は削除できません。'
  }
};
